<template>
  <div v-if="items" class="hidden md:flex gap-[5px] md:gap-[20px] items-center text-[10px] md:text-[16px]">
    <div v-for="item in items">
      <a
        :href="item.link"
        target="_blank"
        class="cursor-pointer"
        >{{ item.name }}</a
      >
    </div>
  </div>
  <div v-else></div>
</template>

<script setup>
defineProps({
  items: Object,
});
</script>
